import * as contentful from "contentful";

export const client = contentful.createClient({
  space: "o1cztwk6agbv",
  accessToken: "b595wbhiJMSmw7DDtPHbKrBTUtSUSpUCQ8Ngng4YXvk",
});
